import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { Form, Button, Input, Modal } from "antd";
import { ReactComponent as Tick } from "../../../assets/Icons/tick.svg";
import StyledPeoplePage from "../Settings/People/style";

const CreateEditGroup = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve the passed state
  const { selectedData } = location.state || {};
  const isEditMode = !!selectedData;

  useEffect(() => {
    if (selectedData) {
      form.setFieldsValue(selectedData);
    }
  }, [form, selectedData]);

  const handleCancel = () => {
    navigate("/group");
  };

  const onFinish = (values) => {
    if (isEditMode) {
      console.log("Edited successfully:", values);
      setModalMessage("Saved");
    } else {
      console.log("Created successfully:", values);
      setModalMessage("Created");
    }
    setIsModalVisible(true);
    setTimeout(() => {
      setIsModalVisible(false);
      navigate("/group");
    }, 2000);
  };

  return (
    <StyledPeoplePage>
      <div>
        <div className="flex text-left gap-3">
          <p onClick={() => navigate("/group")} className="custom-field">
            Group
          </p>
          <RightOutlined className="w-[24px] h-[24px]" />
          <p className="editing-creating-text">
            {isEditMode ? "Editing Group" : "Creating Group"}
          </p>
        </div>
        <br />
        <Form
          form={form}
          name="custom-form"
          onFinish={onFinish}
          layout="vertical"
          className="flex justify-between"
        >
          <div className="w-[100%]">
            <Form.Item
              name="group"
              label={<span className="name-text">Group</span>}
              rules={[
                { required: true, message: "Please enter the Group Name" },
              ]}
              style={{ textAlign: "left" }}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="description"
              label={<span className="name-text">Description</span>}
              rules={[
                { required: true, message: "Please enter the Description" },
              ]}
              style={{ textAlign: "left" }}
            >
              <Input.TextArea rows={2} />
            </Form.Item>
          </div>

          <div className="button-style1">
            <Button className="cancel-button" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              className="save-create-button"
              type="primary"
              onClick={() => form.submit()}
            >
              {isEditMode ? "Save" : "Create"}
            </Button>
          </div>
        </Form>
      </div>
      <Modal
        width={180}
        height={100}
        open={isModalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "34px", height: "34px" }} />
          <p style={{ fontSize: "16px", fontWeight: 400 }}>{modalMessage}</p>
        </div>
      </Modal>
    </StyledPeoplePage>
  );
};

export default CreateEditGroup;
